export default function SectionHeader({ eyebrow, title, description, align = "left" }) {
  const alignClass = align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`max-w-3xl ${alignClass} mb-14 sm:mb-20`}>
      <div className="font-display text-[10px] sm:text-xs tracking-[0.35em] text-[#D4AF37] mb-4">
        — {eyebrow}
      </div>
      <h2 className="font-serif-luxe text-3xl sm:text-4xl lg:text-5xl text-[#F8F1DC] leading-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-[#E0D5B8] text-sm sm:text-base leading-relaxed max-w-2xl">
          {description}
        </p>
      )}
      <div className="mt-6 w-24 hairline-gold" />
    </div>
  );
}
